import React, { useEffect } from "react";
import { Form, Input, Modal, Select } from "antd";

const privilegeOptions = [
  { label: "User", value: 0 },
  { label: "Enroller", value: 2 },
  { label: "Admin", value: 6 },
  { label: "Super Admin", value: 14 },
];

const AdmsUserModal = ({ open, onCancel, onSubmit, loading, machine, record }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      return;
    }

    form.setFieldsValue({
      pin: record?.pin_manual ?? "",
      name: record?.user_name ?? "",
      privilege: record?.privilege ?? 0,
      password: record?.password ?? "",
      card: record?.card ?? "",
      group: record?.adms_acc_group ?? "1",
      tz: record?.adms_timezone ?? "",
      category: record?.adms_category ?? "0",
    });
  }, [open, record, form]);

  const handleFinish = (values) => {
    onSubmit({
      machine_id: machine?.id,
      machine_user_id: record?.id,
      ...values,
    });
  };

  return (
    <Modal
      open={ open }
      title={ record ? "Update ADMS User" : "Add ADMS User" }
      okText={ record ? "Update User" : "Create User" }
      onCancel={ onCancel }
      okButtonProps={ { loading } }
      onOk={ () => form.submit() }
      destroyOnClose
      width={ 720 }
    >
      <Form form={ form } layout="vertical" onFinish={ handleFinish }>
        <div className="row">
          <div className="col-md-6">
            <Form.Item name="pin" label="PIN" rules={ [{ required: true, message: "PIN is required" }] }>
              <Input placeholder="Enter device PIN" />
            </Form.Item>
          </div>
          <div className="col-md-6">
            <Form.Item name="name" label="Name" rules={ [{ required: true, message: "Name is required" }] }>
              <Input placeholder="Enter employee name" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item name="privilege" label="Privilege">
              <Select
                options={ privilegeOptions }
                placeholder="Select privilege"
              />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item name="password" label="Password">
              <Input placeholder="Optional device password" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item name="card" label="Card">
              <Input placeholder="Optional card number" />
            </Form.Item>
          </div>
          {/* <div className="col-md-4">
            <Form.Item name="group" label="Group">
              <Input placeholder="Default group" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item name="tz" label="Time Zone Mask">
              <Input placeholder="Device TZ string" />
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item name="category" label="Category">
              <Input placeholder="Category code" />
            </Form.Item>
          </div> */}
        </div>
      </Form>
    </Modal>
  );
};

export default AdmsUserModal;
